import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null); // null = checking, false = anon, obj = logged in
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/auth/me");
                setUser(data);
            } catch {
                setUser(false);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const applyLogin = (data) => {
        if (data?.access_token) localStorage.setItem("smm_token", data.access_token);
        setUser({ id: data.id, name: data.name, email: data.email, phone: data.phone, role: data.role });
    };

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        applyLogin(data);
        return data;
    };

    const adminLogin = async (email, password) => {
        const { data } = await api.post("/auth/admin-login", { email, password });
        applyLogin(data);
        return data;
    };

    const register = async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        applyLogin(data);
        return data;
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch (_) {}
        localStorage.removeItem("smm_token");
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, adminLogin, register, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
